import { EUserRoles, TUserRoleInstitutionSettingsCamel } from '@/types';

// assign priority role
// priorities: device > provider > clinician > patient > admin
// device has only one role
/**
 * Sorts an array of user institution roles based on predefined priority.
 * Priority order: DEVICE > PATIENT > PRESENTER > PROVIDER > COORDINATOR > ADMIN > GUEST.
 * Roles outside this list are dropped.
 * @param userInstitutionRoles - Array of user roles with institution settings.
 * @returns A new array of user roles sorted according to priority.
 */
export const sortByUserInstitutionRoles = (
  userInstitutionRoles: TUserRoleInstitutionSettingsCamel[],
) => {
  const rolePriority = [
    EUserRoles.DEVICE,
    EUserRoles.PATIENT,
    EUserRoles.PRESENTER,
    EUserRoles.PROVIDER,
    EUserRoles.COORDINATOR,
    EUserRoles.ADMIN,
    EUserRoles.GUEST,
  ];

  return [...userInstitutionRoles]
    .filter((item) => rolePriority.includes(item.role))
    .sort(
      (a, b) => rolePriority.indexOf(a.role) - rolePriority.indexOf(b.role),
    );
};
